// Unsaved Place Enrichment review marks (CC-27-01). They live here, not in the
// review's component state: the admin dashboard renders the review only while
// its tab is active, so switching sections unmounts it — and `beforeunload`
// never fires for an in-app switch (nor for browser back/forward between
// tabs). Keeping the marks at module level means no in-app navigation can drop
// them. The unload warning follows the marks, not the component, so a refresh
// or tab close after a section switch still warns. Signing out clears them
// (invalidateSessionCaches): the next admin on this tab must not inherit them.

let unsavedMarks = {};

const warnOnUnload = (e) => { e.preventDefault(); e.returnValue = ''; };
let warning = false;

function syncUnloadWarning() {
  const want = Object.keys(unsavedMarks).length > 0;
  if (want === warning || typeof window === 'undefined') return;
  if (want) window.addEventListener('beforeunload', warnOnUnload);
  else window.removeEventListener('beforeunload', warnOnUnload);
  warning = want;
}

export function getUnsavedMarks() {
  return unsavedMarks;
}

// `update` is the next marks object, or a function of the current one.
export function writeUnsavedMarks(update) {
  unsavedMarks = typeof update === 'function' ? update(unsavedMarks) : update;
  syncUnloadWarning();
  return unsavedMarks;
}

export function clearUnsavedMarks() {
  writeUnsavedMarks({});
}
